import { OFFER_FOR_PURCHASE } from '../../constants';

import calculateTotalsForPurchase from './calculateTotalsForPurchase';
import applyOfferToStagedPurchases from './applyOfferToStagedPurchases';

export default function stagedPurchasesWithTotals(
  purchases: Purchase[],
  choiceOrderingMethod: ChoiceOrderingMethod,
  selectedOffer: Offer | undefined,
  couponOrderingMethod: CouponOrderingMethod,
  choiceSetDiscountConfig?: ChoiceSetQuantityDiscountConfig,
): PurchaseWithTotals[] {
  const purchasesWithTotals = purchases.map(purchase => ({
    ...purchase,
    ...calculateTotalsForPurchase(
      purchase,
      choiceOrderingMethod,
      true,
      choiceSetDiscountConfig,
    ),
  }));

  if (!selectedOffer) {
    return purchasesWithTotals;
  }

  if (OFFER_FOR_PURCHASE.includes(selectedOffer.type)) {
    return applyOfferToStagedPurchases(
      purchasesWithTotals,
      selectedOffer,
      couponOrderingMethod,
    );
  }

  return purchasesWithTotals;
}
